import { setFulfilled, setPending } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  OfficialGroupsLoadAction,
  OfficialGroupsLoadMoreFulfilledAction,
} from '../../domains/officialGroups/actions.types';

import type { ViewerOfficialGroups } from './types';

export const initialState: ViewerOfficialGroups = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type ViewerOfficialGroupsAction = OfficialGroupsLoadAction | OfficialGroupsLoadMoreFulfilledAction;

const reducer: Reducer<ViewerOfficialGroups, ViewerOfficialGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'OFFICIAL_GROUPS.LOAD_PENDING': {
      return setPending();
    }
    case 'OFFICIAL_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerOfficialGroups);
    case 'OFFICIAL_GROUPS.LOAD_MORE_FULFILLED':
      return setFulfilled({
        officialGroupIds: [
          ...new Set([
            ...(state.fulfilled?.officialGroupIds || []),
            ...action.payload.entities.viewerOfficialGroups.officialGroupIds,
          ]),
        ],
      });
    default:
      return state;
  }
};

export default reducer;
